import { PieChartDataItem } from '../components/DataPieChart'
import { theme } from '@ketch-com/deck'

interface ExtendedReportData {
  pending?: number
  overdue?: number
  onTime?: number
  fulfilledSevenDays?: number
  invokedSevenDays?: number
  dueSevenDays?: number
  dueFourteenDays?: number
  dueOneDay?: number
  onTrack?: number
  avgFulfilTime?: number
  totalInvocations?: number
}

export const transformChartData = (
  report?: ExtendedReportData,
  useAlternateColors: boolean = false,
): PieChartDataItem[] => {
  if (!report) return []

  const overdue = report.overdue || 0
  const dueToday = report.dueOneDay || 0
  const dueSoon = Math.max((report.dueFourteenDays || 0) - dueToday, 0)
  const onTrack = report.onTrack || 0

  const total = overdue + dueToday + dueSoon + onTrack
  if (total === 0) return []

  const colorSet = useAlternateColors
    ? {
        overdue: theme.palette.Red.Dark.o100,
        dueToday: theme.palette.Red.Light.o100,
        dueSoon: theme.palette.Orange.Default.o100,
        onTrack: theme.palette.Action.Primary,
      }
    : {
        overdue: theme.palette.Infographics.BlueA.Primary,
        dueToday: theme.palette.Infographics.BlueE.Primary,
        dueSoon: theme.palette.Infographics.GreenA.Secondary,
        onTrack: theme.palette.Infographics.YellowB.Secondary,
      }

  return [
    {
      name: 'Overdue',
      value: overdue,
      color: colorSet.overdue,
      originalCount: overdue,
    },
    {
      name: 'Due Today',
      value: dueToday,
      color: colorSet.dueToday,
      originalCount: dueToday,
    },
    {
      name: 'Due Soon',
      value: dueSoon,
      color: colorSet.dueSoon,
      originalCount: dueSoon,
    },
    {
      name: 'On Track',
      value: onTrack,
      color: colorSet.onTrack,
      originalCount: onTrack,
    },
  ]
}
